// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2107 ? "vendor.prosemirror-tables" : chunkId) + "." + {"2107":"2992e9c08249c9dcbfd1","6980":"38589a49be83e0b461ee"}[chunkId] + ".js";
};